(function () {
  'use strict';

  angular
    .module('service.actionLog', ['factories.serviceHelper'])
    .service('ActionLogService', ActionLogService);

  ActionLogService.$inject = ['$http', 'ServiceHelper'];

  function ActionLogService($http, ServiceHelper) {
    var url = {
      actionLog: 'https://:host/:ipad/gaviota-api/actionLog'
    };

    var keys = ['ipad'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key]
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb)(response.data);
      });
    }

    this.writeActionLog = function writeActionLog(actionLogs, resultCb, errorCb) {
      if (!actionLogs || actionLogs.length === 0) return;
      actionLogs = _.isArray(actionLogs) ? actionLogs : [actionLogs];
      return ServiceHelper.checkCanCallServiceWithoutBeingLoggedIn(function () {
        return respond($http.post(createUrl(url.actionLog, ServiceHelper.defaultUrlParams()), {
          actionLogs: actionLogs
        }), resultCb, errorCb);
      });
    };
  }

})();
